import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const cmsPublicApi = axios.create({ baseURL: `${BASE}/api/cms` });

export const fetchGlobalCms = () =>
  cmsPublicApi.get("/global").then((r) => r.data).catch(() => ({ header: {}, footer: {}, announcement_banner: {}, contact: {} }));

export const fetchPageCms = (page) =>
  cmsPublicApi.get(`/page/${page}`).then((r) => r.data).catch(() => ({}));

export const fetchSeoCms = (path) => {
  const clean = path.startsWith("/") ? path.slice(1) : path;
  return cmsPublicApi.get(`/seo/${clean || "home"}`).then((r) => r.data).catch(() => ({}));
};
